export default "__VITE_ASSET__DyRa9u_o__"